onComplete(function() {
	// Woord "MSN" (hoofdletters, als heel woord) in elke h2/h3 rood kleuren.
	// Niet in de CMS-editor draaien, anders komt het spannetje in de bewerkbare content terecht.
	if (document.body && document.body.hasAttribute('data-editor-mode')) {
		return;
	}

	var pattern = /\bMSN\b/g;

	document.querySelectorAll('h2, h3').forEach(function(heading) {
		var walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT, null);
		var textNodes = [];
		var current;
		while ((current = walker.nextNode())) {
			if (
				current.nodeValue.indexOf('MSN') !== -1 &&
				current.parentNode &&
				!current.parentNode.classList.contains('msn-accent')
			) {
				textNodes.push(current);
			}
		}

		textNodes.forEach(function(node) {
			var text = node.nodeValue;
			pattern.lastIndex = 0;
			if (!pattern.test(text)) {
				return;
			}
			pattern.lastIndex = 0;

			var fragment = document.createDocumentFragment();
			var lastIndex = 0;
			var match;
			while ((match = pattern.exec(text))) {
				if (match.index > lastIndex) {
					fragment.appendChild(document.createTextNode(text.slice(lastIndex, match.index)));
				}
				var span = document.createElement('span');
				span.className = 'msn-accent';
				span.style.color = 'var(--primary)';
				span.textContent = match[0];
				fragment.appendChild(span);
				lastIndex = match.index + match[0].length;
			}
			if (lastIndex < text.length) {
				fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
			}
			node.parentNode.replaceChild(fragment, node);
		});
	});
});